type EnvironmentConfig = {
  ENV: string
  STAGE: string
  CONFIG_BY_STAGE: { [key: string]: { CONFIG_BY_ENV: { [key: string]: any } } }
}

// @ts-ignore
const envConfig = window.__ENVIRONMENT__ as EnvironmentConfig

const { ENV: ENVIRONMENT, STAGE, CONFIG_BY_STAGE } = envConfig
const { KEYCLOAK_HOST, API_HOST } = CONFIG_BY_STAGE[STAGE].CONFIG_BY_ENV[ENVIRONMENT]

export { ENVIRONMENT, KEYCLOAK_HOST, API_HOST }
